/* 2026-11-02 (perf, integration): this file is included once per full-width-media section, so the home page
   ran it twice and the second copy threw "Identifier 'AnimatedScale' has already been declared". The class now
   lives inside the guard (block scope), so a repeat include is a silent no-op. */
if (!customElements.get('animated-scale')) {
  class AnimatedScale extends HTMLElement {
    constructor() {
      super();

      this.observerIntersection = null;
      this.animationClass = null;
      this.animationEnabled = false;
    }

    connectedCallback() {
      this.animationClass =
        this.getAttribute('data-animation-class') || 'animation-scale';
      this.animationEnabled =
        this.getAttribute('data-animation-enabled') === 'true';

      if (!this.animationEnabled) {
        return null;
      }

      this.observerIntersection = new IntersectionObserver(
        this.observationCallback.bind(this),
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      this.observerIntersection.observe(this);
    }

    disconnectedCallback() {
      if (this.observerIntersection) {
        this.observerIntersection.disconnect();
      }
    }

    observationCallback(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.init();
          observer.unobserve(entry.target);
        }
      });
    }

    init() {
      this.classList.add(this.animationClass);
    }
  }

  customElements.define('animated-scale', AnimatedScale);
}
